export default {
  menus: [
    {
      title: 'SMS Query',
      icon: '$finance',
      to: '/query',
    },
    {
      title: 'Sms Send',
      icon: '$apps',
      to: '/send',
    },
  ],
  user: null,
}
